Vue.component('chat-error', {
	props: ['options'],
	template: '<transition v-if="isActive" name="bounce" enter-active-class="bounceInDown" leave-active-class="bounceOutRight" v-bind:css="options.internal.isAnimationCompatibility">'+
	'<div id="error">'+
			'<div class="overlay-content text-center">'+
				'<i class="material-icons md-24 offset-top-120">&#xE002;</i>'+
				'<h3>{{ msg }}</h3>'+
			'</div>'+
	'</div>'+
	'</div>'+
	'</transition>',
	data:function(){
		return {
			isActive:false,
			msg:null,

		}
	},
	mounted: function() {
		var that = this;
		this.$parent.$on('onError', function (msg) {
			if(that.options.internal.isConvy){
				bus.$emit('hideRestartButton', true);
			}
			that.contentShow(true);
			that.showMsgError(msg);
		});

	},
	methods:{
		contentShow:function(val){
			this.isActive = val;
		},
		showMsgError:function(msg){
			this.msg = msg;
		}

	}
})
